export default function redirectFav({ next }) {
  const favoriteWorkplace = "Dashboard"; // SvStore.getters.getUserWorkplaceRoute;
  if (favoriteWorkplace) {
    next(favoriteWorkplace);
  } else {
    next();
  }
}
